import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { listContainer } from './style';
import { Col, Row, Container } from 'react-bootstrap';

const Contents = ({
    fungsinya, listNovelnya
  }) => {
  return (
      <div className={listContainer}>
    

    <Container fluid className="isinya">
      <Row className="justify-content-md-center">
        
      {listNovelnya.map((post) =>(
          <Col className="buatItem">
                    <div className="ceritanyaCard">
                    <img src={post.cover} onClick={()=>fungsinya(post.id)} alt="coverNovel" className="gambarCover"/>
                    <h1 className="judulnya" href="#" onClick={()=>fungsinya(post.id)}>{post.judul}</h1>
                  </div>
                  </Col>
                )
                )}
        
      </Row>
    </Container>
    </div>
  );
};
export default Contents;
